/* ---------------------------------------------------------------------------
   YOURS - Anfrage statt Buchung (12.10.2026), gehoert zu sections/yours-request.liquid.

   Kalender, Saisonpreis, Zusammenfassung und WhatsApp-Text. Alle Texte der
   Seite kommen aus dem JSON-Block der Section (locales yours.request), die
   Preise aus ihren Einstellungen; hier steht keine Zahl und kein sichtbarer
   Text fest - ausser den deutschen Feldwerten fuer die Mail an Mirja.

   Absenden: Shopifys Captcha haengt sich an submit und schickt selbst per
   form.submit() ab. Die eigene Pruefung haengt deshalb am Klick des Knopfs in
   der Capture-Phase (Befund 09.09.2026, Memory kontaktformular-captcha-submit).
   --------------------------------------------------------------------------- */
(function () {
  var root = document.querySelector('[data-yours-request]');
  if (!root) return;
  var form = root.closest('form');
  var cfgEl = form && form.querySelector('[data-yrq-config]');
  if (!form || !cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var P = cfg.price;
  /* Shopifys t-Filter maskiert HTML (I'd -> I&#39;d); fuer textContent und den
     WhatsApp-Text brauchen wir den Klartext. */
  var T = {};
  (function () {
    var ta = document.createElement('textarea');
    Object.keys(cfg.t).forEach(function (k) { ta.innerHTML = cfg.t[k]; T[k] = ta.value; });
  })();
  var KEY = 'yours-request';

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return [].slice.call(root.querySelectorAll(sel)); }

  var today = new Date(); today.setHours(0, 0, 0, 0);
  var state = { date: null, slot: null, guests: 2 };
  var errOn = { date: false, slot: false };

  /* ---------- Saison und Preis ---------- */
  function inRange(m, r) { return r[0] <= r[1] ? (m >= r[0] && m <= r[1]) : (m >= r[0] || m <= r[1]); }
  function seasonOf(d) {
    var m = d.getMonth() + 1;
    if (!inRange(m, cfg.months.open)) return null;
    return inRange(m, cfg.months.high) ? 'high' : 'low';
  }
  function kindOf(slot) { return slot === 'full' ? 'full' : (slot ? 'half' : null); }
  function priceFor(season, kind) {
    if (!season || !kind) return 0;
    if (kind === 'full') return season === 'high' ? P.fullHigh : P.fullLow;
    return season === 'high' ? P.halfHigh : P.halfLow;
  }
  function halfAllowed(season) { return !(season === 'high' && !P.halfHigh); }
  function money(n) {
    var sep = cfg.intl === 'en-GB' ? ',' : '.';
    return '€' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }
  function minPrice(kind) {
    var list = kind === 'full' ? [P.fullLow, P.fullHigh] : [P.halfLow, P.halfHigh];
    list = list.filter(function (x) { return x > 0; });
    return list.length ? Math.min.apply(null, list) : 0;
  }
  function fmt(d, opts) { return new Intl.DateTimeFormat(cfg.intl, opts).format(d); }
  function longDate(d) { return fmt(d, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }); }
  var TIMES = { full: '10:00–18:00', am: '10:00–14:00', pm: '14:00–18:00' };

  /* ---------- Monate ---------- */
  var months = [];
  (function () {
    for (var i = 0; i < 30; i++) {
      var d = new Date(today.getFullYear(), today.getMonth() + i, 1);
      if (seasonOf(d)) months.push(d);
    }
  })();
  var idx = 0;
  var focusKey = null; // Tag, der beim Neuzeichnen den Fokus bekommt

  function dayKey(d) { return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); }

  function renderCal() {
    var cal = $('[data-yrq="cal"]');
    if (!cal) return;
    cal.innerHTML = '';
    var tabTarget = null;
    for (var k = 0; k < 2; k++) {
      var mo = months[idx + k];
      if (!mo) break;
      var s = seasonOf(mo);
      var wrap = document.createElement('div');
      wrap.className = 'yrq-month';
      var head = document.createElement('div');
      head.className = 'yrq-month-h';
      var b = document.createElement('b');
      b.textContent = fmt(mo, { month: 'long', year: 'numeric' });
      var tag = document.createElement('span');
      tag.textContent = T[s] + ' · ' + money(priceFor(s, 'full'));
      if (s === 'high') tag.className = 'is-high';
      head.appendChild(b); head.appendChild(tag);
      wrap.appendChild(head);

      var dow = document.createElement('div');
      dow.className = 'yrq-dow';
      dow.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < 7; i++) {
        var x = document.createElement('span');
        x.textContent = fmt(new Date(2024, 0, 1 + i), { weekday: 'short' }).replace('.', '');
        dow.appendChild(x);
      }
      wrap.appendChild(dow);

      var grid = document.createElement('div');
      grid.className = 'yrq-days';
      var first = (mo.getDay() + 6) % 7;
      for (var e = 0; e < first; e++) grid.appendChild(document.createElement('span'));
      var n = new Date(mo.getFullYear(), mo.getMonth() + 1, 0).getDate();
      for (var dn = 1; dn <= n; dn++) {
        var d = new Date(mo.getFullYear(), mo.getMonth(), dn);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'yrq-day';
        btn.textContent = dn;
        btn.setAttribute('data-key', dayKey(d));
        btn.setAttribute('tabindex', '-1');
        var past = d < today;
        if (past) btn.setAttribute('aria-disabled', 'true');
        if (+d === +today) btn.classList.add('is-today');
        var picked = state.date && +state.date === +d;
        btn.setAttribute('aria-pressed', picked ? 'true' : 'false');
        btn.setAttribute('aria-label', longDate(d) + ', ' + T[s]);
        if (errOn.date) btn.setAttribute('aria-describedby', 'yrq-err-date');
        if (!past && (picked || (!tabTarget && !state.date))) tabTarget = btn;
        if (picked) tabTarget = btn;
        (function (d, past) {
          btn.addEventListener('click', function () {
            if (past) return;
            focusKey = dayKey(d);
            pickDate(d);
          });
        })(d, past);
        grid.appendChild(btn);
      }
      wrap.appendChild(grid);
      cal.appendChild(wrap);
    }
    if (!tabTarget) tabTarget = cal.querySelector('.yrq-day:not([aria-disabled="true"])');
    if (tabTarget) tabTarget.setAttribute('tabindex', '0');
    if (focusKey) {
      var f = cal.querySelector('[data-key="' + focusKey + '"]');
      if (f) { f.setAttribute('tabindex', '0'); f.focus(); }
      focusKey = null;
    }
    $('[data-yrq="prev"]').disabled = idx === 0;
    $('[data-yrq="next"]').disabled = idx >= months.length - 2;
  }

  /* Pfeiltasten im Kalender: Tag fuer Tag, Woche fuer Woche, ueber Monatsgrenzen. */
  root.addEventListener('keydown', function (ev) {
    var btn = ev.target.closest && ev.target.closest('.yrq-day');
    if (!btn) return;
    var step = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[ev.key];
    if (!step) return;
    ev.preventDefault();
    var p = btn.getAttribute('data-key').split('-');
    var d = new Date(+p[0], +p[1] - 1, +p[2] + step);
    if (!seasonOf(d)) return;
    var mi = months.findIndex(function (m) { return m.getFullYear() === d.getFullYear() && m.getMonth() === d.getMonth(); });
    if (mi < 0) return;
    var shown = window.matchMedia('(max-width: 719px)').matches ? 1 : 2;
    if (mi < idx) idx = mi;
    else if (mi > idx + shown - 1) idx = Math.min(mi - shown + 1, months.length - 2);
    focusKey = dayKey(d);
    renderCal();
  });

  function pickDate(d) {
    state.date = d;
    var s = seasonOf(d);
    if (!halfAllowed(s) && state.slot !== 'full') state.slot = 'full';
    if (state.slot) clearErr('slot');
    clearErr('date');
    update();
  }

  /* ---------- Anzeige ---------- */
  function update() {
    var s = state.date ? seasonOf(state.date) : null;
    var halfOk = halfAllowed(s);

    $$('[data-yrq-opt]').forEach(function (lab) {
      var v = lab.getAttribute('data-yrq-opt');
      var input = lab.querySelector('input');
      var off = v !== 'full' && !halfOk;
      input.disabled = off;
      input.checked = state.slot === v;
      lab.classList.toggle('is-off', off);
      var pEl = lab.querySelector('[data-yrq-price]');
      var kind = v === 'full' ? 'full' : 'half';
      if (off) pEl.textContent = '—';
      else if (s) pEl.textContent = money(priceFor(s, kind));
      else pEl.textContent = T.from + money(minPrice(kind));
    });
    var note = $('[data-yrq="half-note"]');
    if (note) note.hidden = halfOk;

    var low = $('[data-yrq="rate-low"]'), high = $('[data-yrq="rate-high"]');
    if (low) low.textContent = T.fullShort + ' ' + money(P.fullLow) + ' · ' + T.halfShort + ' ' + money(P.halfLow);
    if (high) high.textContent = T.fullShort + ' ' + money(P.fullHigh) + ' · ' + (P.halfHigh ? T.halfShort + ' ' + money(P.halfHigh) : T.fullOnly);

    $('[data-yrq="guests"]').textContent = state.guests;
    $('[data-yrq="minus"]').disabled = state.guests <= 1;
    $('[data-yrq="plus"]').disabled = state.guests >= 11;

    var sd = $('[data-yrq="s-date"]');
    sd.textContent = state.date ? longDate(state.date) : T.noDate;
    sd.classList.toggle('is-none', !state.date);
    $('[data-yrq="s-length"]').textContent = state.slot ? T[state.slot] + ' · ' + TIMES[state.slot] : '—';
    $('[data-yrq="s-guests"]').textContent = state.guests + ' ' + (state.guests === 1 ? T.guestOne : T.guestMany);
    $('[data-yrq="s-season"]').textContent = s ? T[s] : '—';
    var kind = kindOf(state.slot);
    var price;
    if (s && kind) price = money(priceFor(s, kind));
    else if (s) price = halfOk ? T.from + money(priceFor(s, 'half')) : money(priceFor(s, 'full'));
    else if (kind) price = T.from + money(minPrice(kind));
    else price = T.from + money(Math.min(minPrice('half') || Infinity, minPrice('full') || Infinity));
    $('[data-yrq="s-price"]').textContent = price;

    var shortEl = $('[data-yrq="short"]');
    if (shortEl) shortEl.hidden = !(state.date && (state.date - today) < 2 * 864e5);
    var sum = $('[data-yrq="err-sum"]');
    if (sum && sum.classList.contains('is-on')) showSummary(missingList());

    renderCal();
    writeOut(s, kind);
    save();
  }

  /* Felder fuer die Mail an Mirja: deutsch, unabhaengig von der Seitensprache. */
  var DE_SLOT = { full: 'Ganzer Tag, 10–18 Uhr', am: 'Halber Tag vormittags, 10–14 Uhr', pm: 'Halber Tag nachmittags, 14–18 Uhr' };
  function writeOut(s, kind) {
    function set(k, v) { var el = form.querySelector('[data-yrq-out="' + k + '"]'); if (el) el.value = v; }
    var de = function (d) { return new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' }).format(d); };
    set('date', state.date ? de(state.date) : '');
    set('length', state.slot ? DE_SLOT[state.slot] : '');
    set('guests', String(state.guests));
    set('season', s ? (s === 'high' ? 'Hochsaison' : 'Nebensaison') : '');
    set('price', s && kind ? '€' + String(priceFor(s, kind)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') : '');
    buildWa(s, kind);
  }

  function buildWa(s, kind) {
    var a = $('[data-yrq="wa"]');
    if (!a) return;
    var lines = [T.waIntro, ''];
    if (state.date) lines.push(T.waDate + ': ' + longDate(state.date));
    if (state.slot) lines.push(T.waLength + ': ' + T[state.slot] + ', ' + TIMES[state.slot]);
    lines.push(T.waGuests + ': ' + state.guests);
    if (s && kind) lines.push(T.waPrice + ': ' + money(priceFor(s, kind)) + ' (' + T[s] + ')');
    var name = form.querySelector('#yrq-name').value.trim();
    if (name) lines.push(T.waName + ': ' + name);
    var msg = form.querySelector('#yrq-msg').value.trim();
    if (msg) { lines.push(''); lines.push(msg); }
    a.href = 'https://wa.me/' + cfg.wa + '?text=' + encodeURIComponent(lines.join('\n'));
  }

  /* ---------- Merken (Seitenwechsel, Fehler vom Server) ---------- */
  function save() {
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ date: state.date ? +state.date : null, slot: state.slot, guests: state.guests }));
    } catch (e) {}
  }
  function restore() {
    try {
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return;
      var o = JSON.parse(raw);
      if (o.date) { var d = new Date(o.date); if (d >= today && seasonOf(d)) state.date = d; }
      if (o.slot) state.slot = o.slot;
      if (o.guests >= 1 && o.guests <= 11) state.guests = o.guests;
    } catch (e) {}
  }

  /* ---------- Fehler ---------- */
  function setErr(name, on) {
    if (name === 'date' || name === 'slot') {
      errOn[name] = on;
      var p = root.querySelector('[data-yrq-err="' + name + '"]');
      if (p) p.style.display = on ? 'block' : '';
      if (name === 'date') $$('.yrq-day').forEach(function (b) { if (on) b.setAttribute('aria-describedby', 'yrq-err-date'); else b.removeAttribute('aria-describedby'); });
      if (name === 'slot') $$('[data-yrq-opt] input').forEach(function (i) { if (on) i.setAttribute('aria-describedby', 'yrq-err-slot'); else i.removeAttribute('aria-describedby'); });
      return;
    }
    var f = root.querySelector('[data-yrq-field="' + name + '"]');
    if (!f) return;
    f.classList.toggle('yrq-bad', on);
    var i = f.querySelector('input');
    if (i) i.setAttribute('aria-invalid', on ? 'true' : 'false');
  }
  function clearErr(name) { setErr(name, false); }

  function missingList() {
    var m = [];
    if (!state.date) m.push(T.missDate);
    if (!state.slot) m.push(T.missSlot);
    if (!form.querySelector('#yrq-name').value.trim()) m.push(T.missName);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.querySelector('#yrq-email').value.trim())) m.push(T.missEmail);
    return m;
  }
  function showSummary(list) {
    var sum = $('[data-yrq="err-sum"]');
    if (!sum) return;
    sum.classList.toggle('is-on', list.length > 0);
    sum.textContent = list.length ? T.missing.replace('{list}', list.join(', ')) : '';
  }

  function check() {
    var bad = [];
    if (!state.date) bad.push('date');
    if (!state.slot) bad.push('slot');
    var name = form.querySelector('#yrq-name').value.trim();
    var mail = form.querySelector('#yrq-email').value.trim();
    if (!name) bad.push('name');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) bad.push('email');
    ['date', 'slot', 'name', 'email'].forEach(function (k) { setErr(k, bad.indexOf(k) > -1); });
    return bad;
  }

  /* ---------- Ereignisse ---------- */
  $('[data-yrq="prev"]').addEventListener('click', function () { if (idx > 0) { idx--; renderCal(); } });
  $('[data-yrq="next"]').addEventListener('click', function () { if (idx < months.length - 2) { idx++; renderCal(); } });
  $('[data-yrq="minus"]').addEventListener('click', function () { if (state.guests > 1) { state.guests--; update(); } });
  $('[data-yrq="plus"]').addEventListener('click', function () { if (state.guests < 11) { state.guests++; update(); } });
  $$('[data-yrq-opt] input').forEach(function (i) {
    i.addEventListener('change', function () { if (i.checked) { state.slot = i.value; clearErr('slot'); update(); } });
  });
  ['#yrq-name', '#yrq-msg'].forEach(function (sel) {
    form.querySelector(sel).addEventListener('input', function () { var s = state.date ? seasonOf(state.date) : null; buildWa(s, kindOf(state.slot)); });
  });
  ['name', 'email'].forEach(function (k) {
    var i = form.querySelector('#yrq-' + k);
    i.addEventListener('input', function () { if (i.getAttribute('aria-invalid') === 'true') check(); });
  });

  var send = $('[data-yrq="send"]');
  var sendLabel = send.textContent;
  var sending = false;
  var leaving = false;
  window.addEventListener('pagehide', function () { leaving = true; });
  window.addEventListener('beforeunload', function () { if (sending) leaving = true; });
  send.addEventListener('click', function (ev) {
    if (sending) { ev.preventDefault(); ev.stopImmediatePropagation(); return; }
    var bad = check();
    showSummary(missingList());
    if (bad.length) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
      var first = bad[0];
      var target;
      if (first === 'date') target = $('.yrq-day[tabindex="0"]') || $('[data-yrq="cal"]');
      else if (first === 'slot') target = $('[data-yrq-opt] input:not(:disabled)');
      else target = form.querySelector('#yrq-' + first);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { if (target.focus) target.focus({ preventScroll: true }); }, 300);
      }
      return;
    }
    /* Ab hier geht die Anfrage raus. Erst nach diesem Klick sperren, sonst
       verliert der Browser den Submit; nach 10 s wieder freigeben, falls ein
       Captcha dazwischenkam und abgebrochen wurde. */
    sending = true;
    setTimeout(function () { send.setAttribute('aria-disabled', 'true'); send.textContent = T.sending; }, 0);
    /* Freigeben nur, wenn die Seite nach 30 s noch steht (Captcha abgebrochen,
       Netz weg). Ist sie schon auf dem Weg zum Absenden, bleibt der Knopf zu. */
    setTimeout(function () {
      if (leaving) return;
      sending = false; send.removeAttribute('aria-disabled'); send.textContent = sendLabel;
    }, 30000);
    try {
      sessionStorage.setItem(KEY + '-fields', JSON.stringify({
        name: form.querySelector('#yrq-name').value, email: form.querySelector('#yrq-email').value,
        phone: form.querySelector('#yrq-phone').value, msg: form.querySelector('#yrq-msg').value
      }));
    } catch (e) {}
    var s = seasonOf(state.date);
    writeOut(s, kindOf(state.slot));
    try {
      sessionStorage.setItem(KEY + '-sent', JSON.stringify({
        name: form.querySelector('#yrq-name').value.trim().split(/\s+/)[0],
        date: +state.date,
        email: form.querySelector('#yrq-email').value.trim()
      }));
    } catch (e) {}
  }, true);

  /* WhatsApp prueft nichts: wer dort schreibt, ist schon im Gespraech. Nur der Text muss aktuell sein. */
  $('[data-yrq="wa"]').addEventListener('click', function () {
    var s = state.date ? seasonOf(state.date) : null;
    buildWa(s, kindOf(state.slot));
  });

  /* ---------- Start ---------- */
  if (cfg.sent) {
    try {
      var o = JSON.parse(sessionStorage.getItem(KEY + '-sent') || 'null');
      var p = root.querySelector('[data-yrq-sent-text]');
      if (o && p && o.date && o.email) {
        p.textContent = T.sentNamed
          .replace('{name}', o.name || '')
          .replace('{date}', longDate(new Date(o.date)))
          .replace('{email}', o.email)
          .replace(/^([^,.]*), \./, '$1.')   /* ohne Vorname kein haengendes Komma */
          .replace(/ ,/g, ',');
      }
      restore();
      sessionStorage.removeItem(KEY + '-sent');
      sessionStorage.removeItem(KEY + '-fields');
      sessionStorage.removeItem(KEY);
    } catch (e) {}
  } else {
    restore();
    if (cfg.error) {
      try {
        var f = JSON.parse(sessionStorage.getItem(KEY + '-fields') || 'null');
        if (f) {
          form.querySelector('#yrq-name').value = f.name || '';
          form.querySelector('#yrq-email').value = f.email || '';
          form.querySelector('#yrq-phone').value = f.phone || '';
          form.querySelector('#yrq-msg').value = f.msg || '';
        }
      } catch (e) {}
    }
  }
  if (state.date) {
    var mi = months.findIndex(function (m) { return m.getFullYear() === state.date.getFullYear() && m.getMonth() === state.date.getMonth(); });
    if (mi > -1) idx = Math.min(mi, Math.max(0, months.length - 2));
  }
  update();
})();
